"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOWER = void 0;
exports.LOWER = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:LOWER not implemented');
    },
};
//# sourceMappingURL=lower.js.map